import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';

const mixinMethods = {
  methods: {
    calculateTaskList(
      dataDetails,
      subcategoryToSearch,
      returnType,
      discountPercentage = 2.0
    ) {
      if (returnType === 1) {
        return this.groupTaskListByValue(dataDetails, subcategoryToSearch, 0);
      }

      if (returnType === 2) {
        let yesGroups = this.groupTaskListByValue(
          dataDetails,
          subcategoryToSearch,
          1
        );
        yesGroups = Object.values(yesGroups).reduce((accumulator, answers) => {
          return accumulator.concat(answers);
        }, []);

        return yesGroups.length;
      }

      if (returnType === 3) {
        const notGroups = this.groupTaskListByValue(
          dataDetails,
          subcategoryToSearch,
          0
        );
        const avg = this.getAVGFromTaskList(
          Object.values(notGroups),
          discountPercentage,
          this.getDetailBySubcategory(dataDetails, subcategoryToSearch).length
        );

        return Formatter.formatNumber(avg);
      }
    },

    getGeneralAVG(dataDetails, subcategories, discountPercentage = 1) {
      const avg = [];
      subcategories.forEach((subcategory) => {
        const notGroups = this.groupTaskListByValue(
          dataDetails,
          subcategory,
          0
        );
        const responseAVG = this.getAVGFromTaskList(
          Object.values(notGroups),
          discountPercentage,
          this.getDetailBySubcategory(dataDetails, subcategory).length
        );

        if (!isNaN(responseAVG)) avg.push(responseAVG);
      });

      const result = avg.reduce((acc, value) => {
        if (!isNaN(value)) return acc + value;
        else return acc;
      });

      return Formatter.formatNumber(result / avg.length);
    },

    getDetailBySubcategory(data, indexToSearch) {
      return data.filter((detail) => {
        const indexSubcategory = `${detail.audit_task_with_trashed.audit_subcategory_with_trashed.id}_${detail.audit_task_with_trashed.audit_subcategory_with_trashed.name}`;

        return indexSubcategory === indexToSearch;
      });
    },

    groupTaskListByValue(data, indexToSearch = null, valueToValidate = null) {
      let detailBySubcategory = data;
      if (indexToSearch) {
        detailBySubcategory = this.getDetailBySubcategory(data, indexToSearch);
      }

      return detailBySubcategory.reduce((accumulator, detail) => {
        const groupName = detail.audit_task_with_trashed.name;
        const value = detail.audit_inspection_answers[0].value;

        if (Number(value) === valueToValidate || valueToValidate === null) {
          if (!accumulator[groupName]) {
            accumulator[groupName] = [];
          }

          accumulator[groupName].push(value);
        }

        return accumulator;
      }, {});
    },

    getAVGFromTaskList(groups, discountPercentage, dataLength) {
      if (Number(discountPercentage) <= 0) {
        discountPercentage = 100 / dataLength;
      }

      const notGroups = groups.reduce((accumulator, answers) => {
        return accumulator.concat(answers);
      }, []);

      const result = 100 - notGroups.length * discountPercentage;
      if (result < 0) return 0;

      return result;
    },

    calculateRowAVG(evaluation, subcategory, format = true) {
      let count = 0;
      let total = 0;

      this.seletedData.table[evaluation].forEach((dataEvaluations) => {
        total += Number(
          this.calculateTaskList(
            dataEvaluations.audit_inspection_details,
            subcategory,
            3,
            dataEvaluations.audit_header_with_trashed.discount_percentage
          )
        );

        count++;
      });

      return format ? Formatter.formatNumber(total / count) : total / count;
    },

    accumulateRowAverages(evaluation, subcategories) {
      const accumulatedAverages = [];

      subcategories.forEach((subcategory) => {
        const average = this.calculateRowAVG(evaluation, subcategory, false);
        accumulatedAverages.push(average);
      });

      const farmAVG = accumulatedAverages.reduce((acc, value) => acc + value);

      return Formatter.formatNumber(farmAVG / subcategories.length);
    },

    getSubjectiveTasks() {
      const subjectiveTasks = [];

      data.farms.forEach((farm) => {
        farm.audit_inspection_details.forEach((evaluation) => {
          const subjectiveEvaluationTasks =
            evaluation.audit_inspection_answers.filter(
              (response) =>
                response.audit_task_with_trashed.calification_type ===
                'Subjetiva'
            );

          subjectiveTasks.push(...subjectiveEvaluationTasks);
        });
      });

      return subjectiveTasks;
    },

    getSubcategoryGeneral(detail, indexSubcategory) {
      const dataDetail = this.getDetailBySubcategory(detail, indexSubcategory);

      const allowedCalificationTypes = ['Texto', 'Fecha', 'Hora'];
      const dataSources = ['Fuente de Datos'];

      return dataDetail.map((detail) => {
        const {
          audit_task_with_trashed: {
            audit_subcategory_with_trashed: { general },
            name,
            calification_type,
          },
          audit_inspection_answers,
        } = detail;

        if (audit_inspection_answers && audit_inspection_answers[0]) {
          const { value, value_two, optionValue } = audit_inspection_answers[0];
          let valueTasks = allowedCalificationTypes.includes(calification_type)
            ? value_two
            : value == 1
              ? $t('common_words.yes')
              : $t('common_words.no');
          valueTasks = dataSources.includes(calification_type)
            ? optionValue
            : valueTasks;

          if (general === 1) {
            return `${name}: ${valueTasks}`;
          }
        }
      });
    },
  },
};

export default mixinMethods;
